import type { ProductImage } from '../../things/types'
import { createModal } from '/@/core/elements/modal'

export interface EditProductModalData {
  productId: string | null
  onSubmit?: (firstImage: ProductImage) => void
}

const { api, component } = createModal<EditProductModalData>(
  'EditProductModal',
  () => import('./EditProductModal.vue'),
  {
    productId: null,
    onSubmit() {
      // noop
    },
  },
)

export const useEditProductModal = api
export default component
